import { render, staticRenderFns } from "./RestorePaymentsReceived.vue?vue&type=template&id=5fcd3f5c&scoped=true"
import script from "./RestorePaymentsReceived.vue?vue&type=script&lang=js"
export * from "./RestorePaymentsReceived.vue?vue&type=script&lang=js"
import style0 from "./RestorePaymentsReceived.vue?vue&type=style&index=0&id=5fcd3f5c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcd3f5c",
  null
  
)

export default component.exports